import React, { Component } from 'react'
import axios from 'axios'
import { connect } from 'react-redux'
import SignIn from './SignIn'
import UserLink from './UserLink'

import './CommentSection.css'


let Comment = ({ c }) => <div className='comment'>
		<div className='comment_info'>
			<UserLink {...c} />
			<span className='comment_date'>{new Date(c.created).toLocaleString()}</span>
		</div>
		<div className='comment_body'>{c.body}</div>
	</div>


class CommentSection extends React.Component {
	state = {
		comment: ''
	}
	
	render() {
		let { comment } = this.state
		let { access_token, v } = this.props
		let comments = v.comments.map(c => <Comment c={c} />)
		return <>
			{
				comments.length > 0 &&
				<div className="comments card" onClick={e => e.stopPropagation()}>
					<h2 className='comments_title'>Comments</h2>
					{comments}
				</div>
			}
			{access_token
				? <form onSubmit={(e) => {e.preventDefault(); v.submitComment(comment); this.setState({comment:''})}} className='submit_comment card' onClick={e => e.stopPropagation()}>
					<h2 className='comments_title'>Add Comment</h2>
					<textarea className='submit_comment_textarea'
						value={comment}
						onChange={e => this.setState({ comment: e.target.value })}
						placeholder="Comment"
						required
					/>
					<button className='custom_btn' type="submit" disabled={comment.length == 0}>Submit Comment</button>
				</form>
				: <div className="submit_comment card">
					<h2 className='comments_title'>Sign in to comment</h2>
					<SignIn>
						<button className='custom_btn'>Sign In</button>
					</SignIn>
				</div>
			}
		</>
	}
}


const mapStateToProps = state => ({
	username: state.username,
	premium: state.premium,
	access_token: state.access_token
})

export default connect(mapStateToProps)(CommentSection)